export const UPLOAD_FILES_EXTENTIONS = ['txt', 'doc', 'docx', 'ppt', 'pptx', 'pdf', 'csv', 'xls', 'xlsx'];
export const RECORDING_FILES_EXTENTIONS = ['mpeg', 'mp4', 'mp3', 'mov', 'avi', 'webm', 'ogg', 'weba'];

export const TUI_FILES_UPLOAD_FILES_EXTENTION = UPLOAD_FILES_EXTENTIONS.map((ext) => `.${ext}`).join(',');
export const TUI_FILES_RECORDING_FILES_EXTENTION = RECORDING_FILES_EXTENTIONS.map((ext) => `.${ext}`).join(',');
